
import { connect } from 'react-redux'
import { formValueSelector, isSubmitting } from 'redux-form'
import Email from './Email'

import { FORM_NAME } from './Form'

import componentWillMount from './Handlers/componentWillMount'
import onClickSubmit from './Handlers/onClickSubmit'
import onClickCancel from './Handlers/onClickCancel'
import onClickDelete from './Handlers/onClickDelete'
import onUpload from './Handlers/onUpload'
import onClickSendNow from './Handlers/onClickSendNow'

const mapStateToProps = (state) => ({

    to: formValueSelector(FORM_NAME)(state, 'to'),
    cc: formValueSelector(FORM_NAME)(state, 'cc'),
    bcc: formValueSelector(FORM_NAME)(state, 'bcc'),
    subject: formValueSelector(FORM_NAME)(state, 'subject'),
    body: formValueSelector(FORM_NAME)(state, 'body'),
    html: formValueSelector(FORM_NAME)(state, 'html'),
    direction: formValueSelector(FORM_NAME)(state, 'direction'),
    from_email: formValueSelector(FORM_NAME)(state, 'from_email'),
    from_name: formValueSelector(FORM_NAME)(state, 'from_name'),
    opened: formValueSelector(FORM_NAME)(state, 'opened'),
    bounced: formValueSelector(FORM_NAME)(state, 'bounced'),
    delivered: formValueSelector(FORM_NAME)(state, 'delivered'),
    click: formValueSelector(FORM_NAME)(state, 'click'),
    complaint: formValueSelector(FORM_NAME)(state, 'complaint'),
    delivered_at: formValueSelector(FORM_NAME)(state, 'delivered_at'),
    opened_at: formValueSelector(FORM_NAME)(state, 'opened_at'),
    click_at: formValueSelector(FORM_NAME)(state, 'click_at'),
    bounced_at: formValueSelector(FORM_NAME)(state, 'bounced_at'),
    complaint_at: formValueSelector(FORM_NAME)(state, 'complaint_at'),
    status: formValueSelector(FORM_NAME)(state, 'status'),
    sent_at: formValueSelector(FORM_NAME)(state, 'sent_at'),
    received_at: formValueSelector(FORM_NAME)(state, 'received_at'),
    created_at: formValueSelector(FORM_NAME)(state, 'created_at'),
    email_attachments: formValueSelector(FORM_NAME)(state, 'email_attachments'),
    timetosend_at: formValueSelector(FORM_NAME)(state, 'timetosend_at'),

    submitting: isSubmitting(FORM_NAME)(state),
    logo: state.modals.Email.logo,

})

const actionCreators = {
    componentWillMount,
    onClickSubmit,
    onClickCancel,
    onClickDelete,
    onUpload,
    onClickSendNow,
}


export default connect(mapStateToProps, actionCreators)(Email)
